import { useEffect } from "react"
import "./Teacher.styles.css"
import { downloadApp } from "../../utils/download"
import { TEACHER_APP_ANDROID, TEACHER_APP_IOS } from "../../consts"

const Teacher = () => {
  useEffect(() => {
    downloadApp("teacher")
  }, [])

  return (
    <div className="root">
      {/* <h1 className="title"></h1> */}
      <div className="header">
        <img src="/white-logo.svg" className="logo" />
        <h1>הורידו עכשיו</h1>
      </div>
      <div className="badges">
        <a href={TEACHER_APP_IOS} target="_blank">
          <img src="/stores/app-store.svg" />
        </a>
        <a href={TEACHER_APP_ANDROID} target="_blank">
          <img src="/stores/play-store.svg" />
        </a>
      </div>
    </div>
  )
}
export default Teacher
